// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"822":"19bb56f245171d24","2938":"ba1b2f0ad157e4d9","3030":"b7f3967b5faa663a","4025":"a77f8d3ca3e5968c","5236":"a933066cd62a04cd","8575":"9ac0c92ae180c660","9229":"a17602947c9f0195"}[chunkId] + ".js";
};